/* eslint-disable react/jsx-props-no-spreading */
// We have to use props spreading because of React Router's history, match and params via props.
import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useAuthContext } from "contexts/useAuthContext";
import { useMutation, useQuery } from "@apollo/client";
import GET_MY_CREDITS from "graphql/queries/GetMyCredits";
import MARK_CREDIT_AS_NOT_TRACK_NEEDED from "graphql/mutations/MarkCreditAsNotTrackNeeded";
import { trackPurchase } from "utils/gtm";
import { Credit } from "types";

const ProtectedRoute: React.FC = ({ children }) => {
  const isLoggedIn = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();

  const { data } = useQuery(GET_MY_CREDITS, {
    fetchPolicy: "network-only",
    skip: !isLoggedIn,
  });
  const [markCreditAsNotTrackNeeded] = useMutation(
    MARK_CREDIT_AS_NOT_TRACK_NEEDED
  );

  useEffect(() => {
    if (!isLoggedIn) return;

    // Find credits that need to be tracked based on two scenarios:
    // 1. Subscription updates every 4 weeks.
    // 2. Charge occur after 7 days buying a trial package when registration.
    const creditsTrackNeeded = data?.myCredits?.credits?.filter(
      (credit: Credit) => credit?.trackNeeded
    );

    creditsTrackNeeded?.forEach((credit: Credit) => {
      const dataTracking = {
        id: credit?.stripePriceId,
        name: credit?.stripePriceId,
        price: credit?.price,
        currency: credit?.currency,
        type: credit.creditType,
        credits: credit.originalAmount,
      };
      // Track purchase credits
      trackPurchase(dataTracking);

      // Reset trackNeeded after tracking the purchase
      markCreditAsNotTrackNeeded({
        variables: {
          input: {
            attributes: {
              id: credit.id,
              trackNeeded: false,
            },
          },
        },
      });
    });
  }, [isLoggedIn, data, markCreditAsNotTrackNeeded]);

  useEffect(() => {
    if (location.pathname === "/my-classes") {
      console.log("location.pathname", location.pathname);
      const ref = localStorage.getItem("ref");
      console.log("ref", ref);
      if (ref) {
        const url = new URL(window.location.href);
        if (!url.searchParams.has("ref")) {
          url.searchParams.set("ref", ref);
          navigate(`${url.pathname}?${url.searchParams.toString()}`, {
            replace: true,
          });
        }
      }
    }
  }, [location, navigate]);

  if (!isLoggedIn) {
    // window.location.href = "/login"; // Redirect to login page and cause a reload
    return <Navigate to="/login" />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default ProtectedRoute;
